import React from "react"
import styled from "styled-components"

import {
  COMPLETED_COLOR,
  IN_PROGRESS_COLOR,
} from "../../../helpers/constants/lawColors"

interface Props {
  completed: boolean
}

const Gutter = ({ completed }: Props) => {
  return (
    <Wrapper completed={completed}>
      <ImageWrapper />
    </Wrapper>
  )
}

interface StyleProps {
  completed: boolean
}
const Wrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 50px;
  background-color: ${({ completed }: StyleProps) =>
    completed ? COMPLETED_COLOR : IN_PROGRESS_COLOR};
`
const ImageWrapper = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
  img {
    opacity: 0.2;
    position: absolute;
    top: 50%;
    left: -10px;
    transform: translateY(-50%);
  }
`

export default Gutter
